<template>
	<ul class="context-menu-container">
		<!-- <li @click="onRefreshClick">
			刷新
		</li> -->
		<li @click="onCloseRightClick">
			关闭右侧
		</li>
		<li @click="onCloseOtherClick">
			关闭其他
		</li>
		<li @click="onCloseAllClick">
			关闭全部
		</li>
	</ul>
</template>

<style lang="scss" scoped>
  .context-menu-container {
    position: fixed;
    z-index: 3000;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    background: #fff;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    font-weight: 400;
    font-size: 12px;
    color: #333;
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
</style>

<script>
export default {
    name: 'ContextMenu',
    props: {
        index: {
            type: Number,
            required: true
        }
    },
    methods: {
        onRefreshClick() {
            // console.log(this)
            this.$router.go(0)
        },
        onCloseRightClick() {
            // console.log(this.index)
            this.$store.commit("removeTagsView", {
                type: "right",
                index: this.index
            });
        },
        onCloseOtherClick() {
            this.$store.commit("removeTagsView", {
                type: "other",
                index: this.index
            });
        },
        onCloseAllClick() {
            this.$store.commit("removeTagsView", {
                type: "all",
                index: this.index
            });
            this.$router.push("/");
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/layout/components/TagsView/ContextMenu.vue